import "./Hr.css";
const Hr = ({ h = "1rem", w = "200px", border = false, className = "" }) => {
    if (border) className += " hr--border";
    return (
        <hr className={`hr ${className}`} style={{ height: h, maxWidth: w }} />
    );
};

export default Hr;